if (document.getElementById('form-home')) {
  new Vue({
    el: '.home-content',
    data: function() {
      var that = this
      $(document).on('change', '#busca-tipo', function() {
        that.tipo = this.value
      })
      $(document).on('change', '#busca-operacao', function() {
        that.operacao = this.value
      })
      $(document).on('change', '#busca-cidade', function() {
        that.cidade = this.value
      })
      $(document).on('change', '#busca-anunciante', function() {
        that.anunciante = this.value
      })

      return {
        operacao: 'comprar',
        tipo: 'apartamento',
        cidade: 'todas-cidades',
        codigo: '',
        url: '',
        preco_de: '',
        preco_ate: '',
        area_de: '',
        area_ate: '',
        codigo: '',
        dormitorios: [],
        suites: [],
        vagas: [],
        anunciante: '',
        keyword: '',
        bairros: false
      }
    },
    watch: {
      operacao: function(val, oldVal) {},
      tipo: function(val, oldVal) {},
      cidade: function(val, oldVal) {}
    },
    methods: {
      limparBairros: function() {
        $('#busca-bairro').val([])
        $('#busca-bairro').trigger('change')
      },
      changeDormitorios: function() {
        const dormitorios = []
        $('.form-select-dormitorios input:checked').each(function(i, el) {
          dormitorios.push(el.value)
        })
        this.dormitorios = dormitorios.join(',')
      },

      changeSuites: function() {
        const suites = []
        $('.form-select-suites input:checked').each(function(i, el) {
          suites.push(el.value)
        })
        this.suites = suites.join(',')
      },

      changeVagas: function() {
        const vagas = []
        $('.form-select-vagas input:checked').each(function(i, el) {
          vagas.push(el.value)
        })
        this.vagas = vagas.join(',')
      },
      showFormCodigo: function() {
        $('#form-home').hide()
        $('#form-codigo').show()
      },
      showFormNormal: function() {
        $('#form-home').show()
        $('#form-codigo').hide()
        $('#form-home').removeClass('form-avancada')
      },
      showFormAvancado: function() {
        $('#form-home').show()
        $('#form-codigo').hide()

        $('#form-home').addClass('form-avancada')

        $('.form-big select[name=cidade]').trigger('change')
      },

      trocaCanais: function(cidade) {},

      getUrlParams: function() {
        var url = ''
        var params = {}

        var bairro = $('.form-big select[name=bairro]')
          .val()
          .join('_')
        if ($('.form-big select[name=cidade]').val() == '') $('.form-big select[name=cidade]').trigger('change')

        var operacao = $('.form-big select[name=operacao]')
          .trigger('change')
          .val()
        var cidade = $('.form-big select[name=cidade]').val() || $('.form-big select[name=cidade]').attr('data-value')
        var tipo = $('.form-big select[name=tipo]')
          .trigger('change')
          .val()
        var acomodacoes = $('.form-big select[name=acomodacoes]')
          .trigger('change')
          .val()

        this.preco_de = $('.form-big input[name=preco_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.preco_ate = $('.form-big input[name=preco_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.area_de = $('.form-big input[name=area_de]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
        this.area_ate = $('.form-big input[name=area_ate]')
          .val()
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')
          .replace('.', '')

        if (cidade == null) cidade = ''

        var cidade = this.cidade.split('/')

        var url = window.base_url_filters + '/'
        if (cidade[0] != '' && cidade[0] != null) url += cidade[0]
        else url += 'todas-cidades'

        if (!$('#main-search.temporada')[0] && operacao != '') {
          url = url + '/' + operacao

          if (tipo == '' && bairro == '' && this.dormitorios != '') {
            url = url + '/quartos/' + this.dormitorios
          }
        }

        if (tipo != '') {
          url = url + '/' + tipo

          if (bairro == '' && this.dormitorios != '') {
            url = url + '/quartos/' + this.dormitorios
          }
        }

        if (bairro != '' && bairro != 'undefined') {
          url = url + '/' + bairro

          if (this.dormitorios != '') {
            url = url + '/quartos/' + this.dormitorios
          }
        }

        if (this.preco_de != '' || this.preco_ate != '')
          params.valor =
            this.preco_de
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '') +
            '-' +
            this.preco_ate
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
        if (this.area_de != '' || this.area_ate != '')
          params.area =
            this.area_de
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '') +
            '-' +
            this.area_ate
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
              .replace('.', '')
        if (this.suites != '') params.suites = this.suites
        if (this.vagas != '') params.vagas = this.vagas
        if (this.anunciante != '' && typeof this.anunciante != 'undefined') params.anunciante = this.anunciante
        if (this.keyword != '') params.keyword = this.keyword

        if ($('#main-search.temporada')[0] && acomodacoes != '') params.acomodacoes = acomodacoes

        return { url: url, params: params }
      },

      submitSimples: function() {
        if ($('#form-home').hasClass('form-avancada')) {
          var search = this.getUrlParams()

          var paramsurl = Object.keys(search.params)
            .map(function(k) {
              if (k == 'push-params') return ''
              return encodeURIComponent(k) + '=' + encodeURIComponent(search.params[k])
            })
            .join('&')

          var url2 = search.url + (paramsurl != '' ? '?' + paramsurl : '')

          window.location.href = url2
        } else {
          var operacao = $(this.$el)
            .find('select[name=operacao]')
            .val()
          var cidade = $(this.$el)
            .find('select[name=cidade]')
            .val()
          var tipo = $(this.$el)
            .find('select[name=tipo]')
            .val()
          var acomodacoes = $(this.$el)
            .find('select[name=acomodacoes]')
            .val()

          if (cidade == null) cidade = ''

          cidade = cidade.split('/')

          var url = window.base_url_filters + '/'
          if (cidade[0] != '' && cidade[0] != null) url += cidade[0]
          else url += 'todas-cidades'

          if (!$('#main-search.temporada')[0]) {
            url += '/'
            url += operacao
          }
          url += '/'
          url += tipo
          if (typeof cidade[1] != 'undefined' && cidade[1] != '' && cidade[1] != null) {
            url += '/'
            url += cidade[1]
          }
          if ($('#main-search.temporada')[0] && acomodacoes && acomodacoes != '' && acomodacoes != null)
            url += '?acomodacoes=' + acomodacoes

          window.location.href = url
        }
      },
      submitCodigo: function() {
        var codigo = $(this.$el)
          .find('input[name=codigo]')
          .val()

        window.location.href = '/busca/codigo/' + codigo
      }
    },
    mounted: function() {
      var urlParams = new URLSearchParams(location.search)

      if (urlParams.get('cadastro') == 'concluido') {
        localStorage.setItem('login_social_media', false)
        localStorage.setItem('nome', '')
        localStorage.setItem('email', '')
        localStorage.setItem('facebook_id', '')
        localStorage.setItem('google_id', '')
      }

      const self = this
      $('#busca-bairro').on('change', function() {
        self.bairros = Array.isArray($(this).val()) && $(this).val().length
      })
    }
  })
}
